/**
 *
 * ActiveTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.greenDark};
    background: ${COLORS.oceanGreenLight};
    border-color: ${COLORS.oceanGreen};

    &&& .MuiChip-icon path {
      fill: ${COLORS.green};
    }
  }
`;

const ActiveTag = (props) => (
  <StyledTag label="Active" icon={<CircleIcon />} {...props} />
);

export default memo(ActiveTag);
